<kendo-dialog
  title="Cambiar contraseña"
  *ngIf="visible"
  (close)="closeDialog()"
  [width]="layoutState.isMobile ? '90%' : '30%'"
>
  <app-change-password
    #changePasswordComponent
    [oldPassword]="true"
  ></app-change-password>
  <kendo-dialog-actions layout="end">
    <button (click)="closeDialog()" kendoButton size="small">
      {{ "BUTTON.CANCEL_LABEL" | translate }}
    </button>
    <button
      [disabled]="
        !changePasswordForm ||
        !changePasswordForm.valid ||
        (loading$ | async) === true
      "
      kendoButton
      (click)="updatePassword()"
      size="small"
      themeColor="primary"
    >
      GUARDAR
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
